import type { WorkflowRow } from "./workflow-runner-state.js";

export type WorkflowRuntimeErrorCode =
  | "workflow_definition_missing"
  | "resume_queue_timeout"
  | "workflow_max_duration";

export type WorkflowTimeoutDecision = {
  error: string;
  errorCode: WorkflowRuntimeErrorCode;
  retryable: boolean;
};

function parseWorkflowDate(value: string | Date | null | undefined): number | null {
  if (!value) return null;
  const ms = value instanceof Date ? value.getTime() : new Date(value).getTime();
  return Number.isFinite(ms) ? ms : null;
}

export function computeWorkflowTimeoutDecision(
  workflow: Pick<WorkflowRow, "name" | "current_step" | "max_duration_ms" | "handler_started_at">,
  nowMs: number,
): WorkflowTimeoutDecision | null {
  const handlerStartedAtMs = parseWorkflowDate(workflow.handler_started_at);
  if (handlerStartedAtMs == null) return null;

  const maxDurationMs = Number(workflow.max_duration_ms);
  if (nowMs - handlerStartedAtMs <= maxDurationMs) return null;

  if (workflow.current_step == null) {
    return {
      error: `workflow "${workflow.name}" exceeded maxDuration of ${workflow.max_duration_ms}ms before first workflow step`,
      errorCode: "resume_queue_timeout",
      retryable: true,
    };
  }

  return {
    error: `workflow "${workflow.name}" exceeded maxDuration of ${workflow.max_duration_ms}ms`,
    errorCode: "workflow_max_duration",
    retryable: false,
  };
}
